module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-md navbar-dark bg-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "active-class": "active",
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/logo.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('div', {
    ref: "nav_collapse",
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "ml-auto mt-4 mt-md-0 navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "active-class": "active",
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Sobre")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/#recursos"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleMenu($event)
      }
    }
  }, [_vm._v("Recursos")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 500,
        offset: 150
      }),
      expression: "{ duration: 500, offset: 150 }"
    }],
    staticClass: "nav-link",
    attrs: {
      "active-class": "active",
      "to": "/#assine"
    }
  }, [_vm._v("Cadastre-se")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa7f0f94","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageHeader.vue
// module id = 356
// module chunks = 1